import { Link, useLocation } from "react-router";
import { Aviso } from "../componentes/ui";
import { CascaPublica } from "../componentes/layout";
import { useTitulo } from "../nucleo/titulo";

export function NaoEncontrada() {
  useTitulo("Página não encontrada");
  const { pathname } = useLocation();

  return (
    <CascaPublica
      titulo="Página não encontrada"
      descricao={
        <>
          O endereço <code>{pathname}</code> não existe neste portal.
        </>
      }
      rodape={
        <>
          <Link to="/">Página inicial</Link>
          <Link to="/entrar">Entrar no portal</Link>
        </>
      }
    >
      <Aviso tom="neutro">
        Se você chegou por um link de convite, ele pode ter sido cortado pelo programa de
        e-mail. Copie o endereço inteiro da mensagem e cole na barra do navegador.
      </Aviso>
    </CascaPublica>
  );
}

/**
 * O mesmo 404, mas dentro da área autenticada.
 *
 * Um endereço desconhecido sob `/app` ou `/admin` pertence a quem já entrou: devolver a
 * tela pública faria a pessoa achar que perdeu a sessão. Aqui a casca e a topbar continuam,
 * e o caminho de volta é a área certa.
 */
export function NaoEncontradaNaArea({ voltarPara }: { voltarPara: string }) {
  const { pathname } = useLocation();

  return (
    <>
      <h1 className="titulo-pagina">Página não encontrada</h1>
      <p className="lead">
        O endereço <code>{pathname}</code> não existe nesta área do portal.
      </p>
      <Aviso tom="neutro">
        <Link to={voltarPara}>Voltar para o início da área</Link>
      </Aviso>
    </>
  );
}

/** Rede de segurança do roteador: erro não tratado vira uma tela que diz o que houve. */
export function ErroInesperado() {
  return (
    <>
      <h1 className="titulo-pagina">Algo quebrou nesta tela</h1>
      <p className="lead">
        O portal encontrou um erro que não sabia tratar. O incidente está no console do
        navegador; se ele se repetir, mande a URL e o horário para a equipe da GEOvendas.
      </p>
      <Aviso tom="erro">
        Nenhum dado foi alterado por causa deste erro — a tela parou antes de fazer
        qualquer coisa.
      </Aviso>
    </>
  );
}

/** A mesma rede de segurança, para as rotas públicas, que não têm a casca da aplicação. */
export function ErroPublico() {
  return (
    <CascaPublica
      titulo="Algo quebrou nesta tela"
      descricao="O portal encontrou um erro que não sabia tratar."
      rodape={<Link to="/">Voltar para a página inicial</Link>}
    >
      <Aviso tom="erro">
        Nada foi alterado. Se o erro se repetir, mande a URL e o horário para a equipe da
        GEOvendas.
      </Aviso>
    </CascaPublica>
  );
}
